<template>
  <div class="builder">
    <transition name="fade">
      <div v-if="submission_uuid && isFinal" class="messages__wrapper layout-container">
        <div
          class="messages messages--status"
        >This form was previously submitted. You may make edits and resubmit the form at any time.</div>
      </div>
    </transition>
    <div>
      <component
        v-for="(element,index) in jsonView"
        :nid="nid"
        :sid="draft_sid"
        :main_sid="submission_uuid"
        :uuid="element.uuid"
        :key="element.uuid"
        :is="element.type"
        :index="index"
        :element="element"
        :mode="true"
        :attributes="attributes"
        :validate="validate"
        :validate-last-step="validate"
        :is-draft="isDraft"
        :countFormCards="countFormCards"
        :status="status"
        :showSubmit="showSubmit"
        :go-view-mode="goViewMode"
        :set-view-mode="setViewMode"
        @submit="submit"
        @validate-form="validateForm"
        @disable-form-validation="disableFormValidation"
        @submit-draft="submitDraft"
        @autosave-start="startAutosave"
        @autosave-stop="stopAutosave"
        @set-value="setValue"
        @validation="updateValidation(index, $event)"
      />
    </div>
    <md-dialog-alert
      :md-active.sync="show_submitted"
      md-title="Activity"
      md-content="Your submission has been saved."
    />
    <md-button
      v-if="countFormCards != 1"
      class="md-raised md-accent icon-right fb-submit-btn right"
      @click="submit"
    >
      Submit
      <md-icon>send</md-icon>
    </md-button>
    <spinner v-if="showLoader"></spinner>
  </div>
</template>

<script>
import Viewer from "./Viewer";
export default {
  name: "FormViewer",
  mixins: [Viewer],
  props: [
    "nid",
    "sid",
    "draft_sid",
    "content",
    "embed",
    "field",
    "elements",
    "go-view-mode",
    "set-view-mode",
    "attributes",
  ],
  computed: {
    valid: {
      cache: false,
      get() {
        if (this.isDraft) {
          return true;
        }
        let errors = this.validation.filter((el) => {
          return el !== true;
        });
        return errors.length == 0;
      },
    },
  },
  data() {
    return {
      evaluation_type: window.drupalSettings.evaluation_type,
      webform_template: this.webform_template || false,
      view_mode: this.mode || false,
      isDraft:
        this.sid && this.sid != ""
          ? window.drupalSettings.form_builder[this.nid]["submissions"][
              this.sid
            ].isDraft
          : true,
      isFinal:
        this.sid &&
        this.sid != "" &&
        window.drupalSettings.form_builder[this.nid]["submissions"][this.sid]
          .isCompleted
          ? true
          : false,
      validate: false,
      validate_last_step: false,
      list: this.elements || [],
      value: {},
      showLoader: false,
      sending: false,
      token: "",
      validation: [],
      autosave: null,
      autosaveEnabled: window.drupalSettings.user.role != 'administrator' &&
        window.drupalSettings.user.role != 'content_creator' &&
        window.drupalSettings.user.role != 'content_manager' &&
        window.drupalSettings.user.role != 'subgroup_administrator' &&
        window.drupalSettings.user.role != 'group_administrator',
      submitted: false,
      show_submitted: false,
      submission_uuid: this.sid,
      draft_submission_uuid: this.draft_sid,
      autosave_interval: window.drupalSettings.autosave_time_interval
        ? window.drupalSettings.autosave_time_interval
        : "5",
      status:
        this.sid && this.sid != ""
          ? window.drupalSettings.form_builder[this.nid]["submissions"][
              this.sid
            ].status
          : this.$status.ACTIVITY_NOT_STARTED,
      original_submission:
        this.sid && this.sid != ""
          ? window.drupalSettings.form_builder[this.nid]["submissions"][
              this.sid
            ].id
          : null,
      resubmit:
        window.drupalSettings.form_builder &&
        window.drupalSettings.form_builder[this.nid]
          ? window.drupalSettings.form_builder[this.nid].resubmit
          : false,
    };
  },
  methods: {
    startAutosave() {
      if (this.isFinal) {
        return;
      }
      let self = this;
      // Autosave.
      window.clearInterval(window.autosave);
      let autosaveInterval = this.autosave_interval * 1000;
      window.autosave = window.setInterval(function () {
        if (!self.sending) {
          self.sending = true;
          self.submitDraft((e) => {}, true);
        }
      }, autosaveInterval);
    },
    stopAutosave() {
      clearInterval(window.autosave);
    },
    submitDraft(callback, isAutosave) {
      if (!this.autosaveEnabled) {
        return callback(true);
      }
      //if (!this.sending) {
      this.sending = true;
      this.sendDraft(isAutosave)
        .then((json) => {
          this.showLoader = false;
          this.submitted = true;
          this.draft_submission_uuid = json.data.id;
          this.sending = false;
          return callback(true);
        })
        .catch(() => {
          this.showLoader = false;
        });
      return callback(false);

      //}
    },
    validateForm() {
      this.validate = true;
      this.isDraft = false;
    },
    disableFormValidation() {
      this.validate = false;
    },
    async updateAttributes() {
      if (!this.valid) {
        //return;
      }
      this.showLoader = true;
      await this.sendDraft(true);
      await this.sendObservationRequest(
        true,
        false,
        this.isFinal,
        this.submission_uuid
      );
      this.showLoader = false;
    },

    async submit() {
      if (!this.valid) {
        return;
      }
      this.showLoader = true;

      this.isFinal = true;
      await this.sendDraft();
      await this.sendObservation();

      this.showLoader = false;
      this.submitted = true;
      this.show_submitted = false;

      // TODO: Add thank you page
      if (this.field == "activity_form") {
        let path = "/observation/" + this.$route.params.id + "/thanks";
        this.$router.push({ path });
      }

      if (document.querySelector(".md-app-scroller")) {
        document.querySelector(".md-app-scroller").scrollTop = 0;
      }
      window.scrollTop = 0;
    },
    updateValidation(index, event) {
      this.validation[index] = event;
      this.validation = this.validation.slice(0);
      this.$emit("validation", this.valid);
    },
    sendDraft(isAutosave) {
      return this.sendObservationRequest(
        isAutosave,
        true,
        this.isFinal,
        this.draft_submission_uuid
      );
    },
    sendObservation() {
      // Clear autosave in case it's still exist.
      clearInterval(window.autosave);
      return this.sendObservationRequest(
        false,
        false,
        true,
        this.submission_uuid
      ).catch((e) => {
        this.showLoader = false;
        // TODO: Add error you page
        if (this.field == "activity_form") {
          let path = "/observation/" + this.$route.params.id + "/error";
          this.$router.push({ path });
        }
        if (document.querySelector(".md-app-scroller")) {
          document.querySelector(".md-app-scroller").scrollTop = 0;
        }
        window.scrollTop = 0;
      });
    },
    sendObservationRequest(isAutosave, isDraft, isCompleted, suuid) {
      let self = this;
      let type = isDraft
        ? self.$submission_type.SUBMISSION_TYPE_TEMP
        : self.$submission_type.SUBMISSION_TYPE_MAIN;
      return self.getToken().then(() => {
        let fetch_headers = new Headers();
        fetch_headers.append("Content-Type", "application/vnd.api+json");
        fetch_headers.append("X-CSRF-Token", self.token);
        let method = suuid && suuid != "" ? "PATCH" : "POST";
        let value = JSON.parse(JSON.stringify(self.value));

        value.isDraft = isDraft;
        value.isStarted = true;
        value.isAutosave = isAutosave;
        value.isCompleted = isCompleted;

        let date = new Date(self.attributes.date);
        let time = new Date(self.attributes.time);
        let allFiles = this.files.concat(this.videos);
        let a_data = {
          data: {
            type: "observation_submission--observation_submission",
            attributes: {
              data: JSON.stringify(value),
              original_submission: self.original_submission,
              submission_type: type,
              is_draft: isDraft,
              date: self.attributes.date
                ? parseInt(self.$moment(date).format("X"))
                : null,
              time: self.attributes.time
                ? parseInt(self.$moment(time).format("X"))
                : null,
            },
            relationships: {
              observation: {
                data: {
                  type: "node--observation",
                  id: self.nid,
                },
              },
              webform_template: {
                data: {
                  type: "webform_template--webform_template",
                  id:
                    window.drupalSettings.form_builder[self.nid].tabs[
                      self.field
                    ].template.uuid,
                },
              },
              attached_files: {
                data: allFiles.map((uuid) => {
                  return {
                    type: "file--file",
                    id: uuid,
                  };
                }),
              },
              learner: {
                data: {
                  type: "user--user",
                  id: self.attributes.learner,
                },
              },
            },
          },
        };

        let entity_uuid = "";
        if (method == "PATCH") {
          a_data.data.id = suuid;
          entity_uuid = "/" + suuid;
        }

        return fetch(
          "/jsonapi/observation_submission/observation_submission" +
          entity_uuid,
          {
            credentials: "include",
            method: method,
            headers: fetch_headers,
            body: JSON.stringify(a_data),
          }
        )
          .then((response) => {
            return response.json();
          })
          .then((json) => {
            if (json && json.errors && json.errors.length) {
              throw new Error(json.errors[0].title);
            }
            // if (json.data && json.data.id) {
            //   self.$emit("set-sid", json.data.id);
            // }
            if (json.data && json.data.id) {
              suuid = json.data.id;
              if (isDraft) {
                this.draft_submission_uuid = json.data.id;
              } else {
                self.submission_uuid = json.data.id;
                self.$emit("set-sid", json.data.id);
              }
            }
            if (!isAutosave) {
              self.$emit("draft-send", true);
            }

            return json;
          });
      });
    },
  },
};
</script>
